module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "async",
      rawName: "v-async",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('title-user', [_vm._v("Ativar TAG")]), _vm._v(" "), _c('div', {
    staticClass: "margin-30"
  }, [_vm._m(0), _vm._v(" "), (_vm.window.document.mobile && _vm.window.document.android) ? _c('button', {
    staticClass: "btn btn-primary btn-scan",
    attrs: {
      "onclick": "Native.openScanner()"
    }
  }, [_vm._v("\n          Escanear veículo\n        ")]) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "icon-marquee align-icon"
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "search"
  }, [_c('i', {
    staticClass: "icon-search-input"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "search",
      "name": "",
      "value": "",
      "placeholder": "Buscar"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.loadingVehicles) ? _c('p', [_vm._v("carregando...")]) : [(_vm.hasAggregate) ? [_c('h3', {
    staticClass: "margin-20 bold"
  }, [_vm._v("Veículos de agregados")]), _vm._v(" "), _c('div', {
    staticClass: "table-white-header tag-table"
  }, [(_vm.aggregateVehicles.length == 0) ? _c('div', {
    staticClass: "alert alert-success margin-t20"
  }, [_vm._v("\n            Não há TAGs para ativar no momento. \n          ")]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "aggregate-tag-list"
  }, _vm._l((_vm.aggregateVehicles), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "tag-item"
    }, [_c('tag', {
      attrs: {
        "vehicle": item,
        "completeData": true
      }
    })], 1)
  }), 0)])] : _vm._e(), _vm._v(" "), [(_vm.hasAggregate) ? _c('h3', {
    staticClass: "margin-b20 margin-t40 bold"
  }, [_vm._v("Veículos próprios")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "table-white-header tag-table"
  }, [(!_vm.vehicles.length && _vm.vehicleStatic.length) ? _c('div', [_c('span', {
    staticClass: "italic"
  }, [_vm._v("Nenhum veículo encontrado.")])]) : _vm._e(), _vm._v(" "), (!_vm.vehicleStatic.length) ? _c('div', {
    staticClass: "alert alert-success margin-t20"
  }, [_vm._v("\n            Não há TAGs para ativar no momento.\n          ")]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "list-tag-activate"
  }, _vm._l((_vm.vehicles), function(vehicle, index) {
    return _c('li', {
      key: index,
      staticClass: "tag-item"
    }, [_c('div', {
      staticClass: "block-plate"
    }, [_c('span', [_vm._v(_vm._s(vehicle.plate))])]), _vm._v(" "), _c('div', {
      staticClass: "block-vehicle"
    }, [_c('b', [_vm._v(_vm._s(vehicle.brandName))]), _vm._v(" "), _c('div', {
      staticClass: "vehicle-model"
    }, [_c('b', [_vm._v(_vm._s(_vm._f("firstWord")(vehicle.modelName)))])]), _vm._v("\n                " + _vm._s(_vm._f("fromSecWord")(vehicle.modelName)) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "block-tag-activate"
    }, [_c('ativar-tag-item', {
      attrs: {
        "vehicle": vehicle.vehicleId,
        "loadings": _vm.loading
      },
      on: {
        "deactivatetagLoading": _vm.deactivatetagLoading,
        "activetagLoading": function($event) {
          return _vm.activatingTag($event)
        }
      }
    })], 1), _vm._v(" "), _c('button', {
      staticClass: "btn show-webview",
      staticStyle: {
        "width": "100%",
        "margin-top": "20px",
        "display": "none"
      },
      attrs: {
        "type": "button",
        "data-vehicle-id": vehicle.vehicleId,
        "onclick": "Native.openBarCodeScanner(this.dataset.vehicleId+'')"
      }
    }, [_vm._v("Escanear")])])
  }), 0)])]]], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "line-height-20"
  }, [_vm._v("\n          Somente depois de fazer a ativação do TAG é que você poderá utilizar os serviços "), _c('b', [_vm._v("Move Mais")]), _vm._v(". Para ativar é\n          fácil, você só precisa informar o "), _c('b', [_vm._v("TAG Número")]), _vm._v(". Se você possui mais de um TAG certifique-se de que o número\n          informado é realmente do TAG fixado naquele veículo.\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "img-tag-line"
  }, [_c('img', {
    staticClass: "img-tag-number",
    attrs: {
      "src": require("../../assets/img/img-ativar-tag-2026.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "info-tag-number"
  }, [_vm._v("Este é o número que você deve informar para fazer a ativação do TAG.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-4f934f91!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/account/tag-activate.vue
// module id = 2123
// module chunks = 1